import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { isEventPosition } from '../../helpers';
export const removeClickEventStmtInstruction = `
### Remove Click Events in Your Application

- syntax: \`remove click_event <event_name> on <source_view>.<source_scope> in <event_position>;\`
- example: \`remove click_event ProductDetailNavigate on ProductList in entity;\`
- example: \`remove click_event ProductDetailNavigate on ProductList.Product in entity;\`
`;
export const stmtRemoveClickEvent = (stmt) => {
    if (!stmt.sourceScopeName) {
        return `remove click_event ${stmt.eventName} on ${stmt.sourceViewName} in ${stmt.eventPosition};`;
    }
    return `remove click_event ${stmt.eventName} on ${stmt.sourceViewName}.${stmt.sourceScopeName} in ${stmt.eventPosition};`;
};
export const removeClickEventHandler = createStructureStatementHandler({
    type: 'remove click_event',
    parse: line => {
        const match = /^remove click_event (?<eventName>\w+) on (?<viewName>\w+)(\.(?<scopeName>\w+))?( in (?<eventPosition>\w+))?/.exec(line);
        return match?.groups
            ? {
                type: 'remove click_event',
                eventName: match.groups.eventName,
                sourceViewName: match.groups.viewName,
                sourceScopeName: match.groups.scopeName,
                eventPosition: match.groups.eventPosition,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => it.removeEvent({
            eventName: stmt.eventName,
            sourceViewName: stmt.sourceViewName,
            sourceScopeName: stmt.sourceScopeName,
            eventPosition: isEventPosition(stmt.eventPosition) ? stmt.eventPosition : undefined,
        }));
    },
});
//# sourceMappingURL=RemoveClickEvent.js.map